import './Team.scss';

class Team {

	constructor(node) {
		this.node = node;
	}

	init() {
		(function ($) {
			$(document).on("ready", () => {
				$('.Team__carousel').slick({
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 1,
					// dots: true,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
							}
						},
					]
				});
			});
		})(jQuery);
	}

}

if (typeof JSModules === "object") {
	JSModules['Team'] = Team;
} else {
	// initialize section
	let section = new Team;
	section.init();
}

export default Team;
